import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.timeout = setTimeout(() => this.close(), 6000)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  close() {
    clearTimeout(this.timeout)
    this.element.classList.add("is-closing")
    this.element.addEventListener("animationend", () => this.element.remove(), { once: true })
  }
}
